import { Injectable }             from '@angular/core';
import { Http, Response }         from '@angular/http';
import { Observable }             from 'rxjs/Observable';
import { ConfigService }          from '../configuracion/config.service';
import { RequestBaseService }     from '../request-base/request-base.service';
import { JwtHttp, AuthService }   from 'ng2-ui-auth';
import { FileUploader }         from 'ng2-file-upload';

import 'rxjs/add/operator/map';

@Injectable()
export class EmailService extends RequestBaseService {
  constructor(
    protected http: JwtHttp,
    protected auth: AuthService,
    config: ConfigService
  ) {
    super(http, auth);
    this.ApiUrl = [config.getApiUrl(), 'email'].join('/');
  }


  public uploadCsv(model: any, proyecto_id: number): Observable<any> {
    console.log('model: ', model);
    let file: FileUploader = model.csv;
    

    return new Observable(observer => {
      if(file.queue.length > 0) {
        file.authToken      = this.auth.getToken();
        file.options.url    = [this.ApiUrl, proyecto_id, 'upload'].join('/');
        file.queue[0].url   = [this.ApiUrl, proyecto_id, 'upload'].join('/');

        file.queue[0].upload();

        file.queue[0]._xhr.onreadystatechange = (e) => {
          if(file.queue[0]._xhr.readyState == 4) {
            //data.imagen = [data.id, 'csv'].join('.');

            observer.next(file.queue[0]._xhr.response);
          } else {
            observer.error('Se presento un problema al cargar el archivo');
          }
        }               
      } else {
        observer.error('No adjunto ningun archivo para cargar');
      }
    });
  }

  public getEmailPorProyecto(id_pro) {
    return this.http
    .get([this.ApiUrl,'proyecto',id_pro].join('/'))
    .map(res => res.json());
  }

  public getEtiquetasProyecto(id_pro) {
    return this.http
    .get([this.ApiUrl,'etiquetas',id_pro].join('/'))
    .map(res => res.json());
  }
  
 

/*  public actualizarRadicado(model: any, id_orden): Observable<any> {
    return this.http
      .put([this.ApiUrl, id_orden,'radicado'].join('/'), {data: model})
      .map(res => res.json());    
  }*/


}



// WEBPACK FOOTER //
// ./src/app/services/email/email.service.ts